// extracted by mini-css-extract-plugin
module.exports = {"versions":"ProductRelations_versions__hb63g","marginRight":"ProductRelations_marginRight__RDOnr"};